import { BaseObject } from '../core/BaseObject';

export class UserImage extends BaseObject {
	userImageId: number;
	fileName: string;
	filePath: string;
}
